import React, { useEffect } from "react";
import { Formik, Field, Form, ErrorMessage } from "formik";
import * as Yup from "yup";
import { reportProjectValidationSchema } from "../../../components/Helpers";
import TextInput from "../../../components/TextInput";
import CustomDropdown from "../../../components/CustomDropdown";
import CustomDataTable from "../../../components/CustomDataTable";
import { useDispatch, useSelector } from "react-redux";
import {
  requestReportsProjects,
  setResetStateReportsProjects,
} from "../../../Redux/ReportsState/ReportsActionCreator";
import { toast } from "react-toastify";
import { requestUsersListActionWithOutPagination } from "../../../Redux/UserState/UserActionCreator";
import moment from "moment";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import Hoc from "../../../components/HOC";
import CustomDatePicker from "../../../components/CustomDatePicker";
import MuiDatePicker from "../../../components/MuiDatePicker";

const Projects = () => {
  const dispatch = useDispatch();
  const usersListState = useSelector(
    (state) => state.UsersListWithOutPagination
  );
  const ReportsProjectsReducer = useSelector((state) => state.ReportsReducer);

  const columns = [
    { name: "Project Name", selector: (row) => row.projectName, sortable: true },
    {
      name: "Start Date",
      selector: (row) => moment(row.startDate).format("MM-DD-YYYY"),
      sortable: false,
    },
    {
      name: "End Date",
      selector: (row) => moment(row.endDate).format("MM-DD-YYYY"),
      sortable: true,
    },
  ];
  const initialValues = {
    userId: "",
    startDate: "",
    endDate: "",
  };
  const usersList = usersListState?.response || [];

  const handleSubmit = (values, { resetForm }) => {
    dispatch(
      requestReportsProjects({
        userId: values.userId,
        startDate: values.startDate,
        endDate: values.endDate,
        page: ReportsProjectsReducer?.page,
        size: ReportsProjectsReducer?.size,
      })
    );
    // resetForm();
  };

  useEffect(() => {
    dispatch(requestUsersListActionWithOutPagination("USER"));
    dispatch(setResetStateReportsProjects());
  }, []);

  const handlePageChange = (page) => {
    dispatch(
      requestReportsProjects({
        page: page,
        size: ReportsProjectsReducer?.size,
        userId: ReportsProjectsReducer?.userId,
        startDate: ReportsProjectsReducer?.startDate,
        endDate: ReportsProjectsReducer?.endDate,
      })
    );
  };

  const handleRowsChange = (size) => {
    dispatch(
      requestReportsProjects({
        page: 0,
        size: size,
        userId: ReportsProjectsReducer?.userId,
        startDate: ReportsProjectsReducer?.startDate,
        endDate: ReportsProjectsReducer?.endDate,
      })
    );
  };

  useEffect(() => {
    if (!ReportsProjectsReducer?.loading && ReportsProjectsReducer?.error) {
      toast.error("No Projects Found / Something went wrong");
      dispatch(setResetStateReportsProjects());
    }
  }, [ReportsProjectsReducer]);

  console.log(usersList, "id");
  return (
    <div className="w-full p-6 ">
      <Formik
        initialValues={initialValues}
        // validationSchema={reportProjectValidationSchema}
        onSubmit={handleSubmit}
      >
        {({
          isSubmitting,
          values,
          errors,
          touched,
          resetForm,
          handleChange,
          setFieldValue,
        }) => (
          <Form className="flex flex-col md:flex-row lg:flex-row gap-5 my-5">
            <div className="lg:w-3/4 md:w-2/3 w-full">
              <CustomDropdown
                value={usersList.find((user) => user.id == values?.userId)}
                name="userId" 
               
                handleChange={(selectedOption) => {
                  setFieldValue("userId", selectedOption?.id);
                  dispatch(setResetStateReportsProjects());
                }}
                customClasses="w-76 text-left"
                placeholder="Select Employee"
                options={usersList}
                handleGetOptionValue={(option) => option.id}
                handleGetOptionName={(option) =>
                  `${option.firstName} ${option.lastName}`}
              />
            </div>
            <div className="lg:w-2/3 md:w-1/2 w-full mt-1">
              <MuiDatePicker
                label="Start Date"
                value={values?.startDate ? moment(values?.startDate) : null}
                onChange={(date) => {
                  setFieldValue("startDate", moment(date).format("MM-DD-YYYY"));
                }}
                // disabled={false}
                className="w-full h-10"
                maxDate={moment()}
              />
              {errors.startDate && touched.startDate && (
                <div className="text-red-500 text-sm">{errors.startDate}</div>
              )}
            </div>
            <div className="lg:w-2/3 md:w-1/2 w-full mt-1">
              <MuiDatePicker
                label="End Date"
                value={values?.endDate ? moment(values?.endDate) : null}
                onChange={(date) => {
                  setFieldValue("endDate", moment(date).format("MM-DD-YYYY"));
                }}
                // disabled={false}
                className="w-full h-10"
                minDate={moment()}
              />
              {errors.endDate && touched.endDate && (
                <div className="text-red-500 text-sm">{errors.endDate}</div>
              )}
            </div>
            <div className="flex gap-6 w-full justify-center">
              <button
                type="submit"
                className="bg-primary w-full text-white px-4 rounded-lg hover:bg-primaryDark"
                   
              >
                Submit
              </button>
              {/* <button
                type="button"
                className={`text-white bg-primary w-full px-4 rounded-lg hover:bg-primaryDark`}
              >
                Generate Report
              </button> */}
            </div>
          </Form>
        )}
      </Formik>
      <CustomDataTable
        columns={columns}
        data={ReportsProjectsReducer?.response?.content || []}
        paginationTotalRows={ReportsProjectsReducer?.response?.totalElements}
        handleChangePage={handlePageChange}
        handleRowsChange={handleRowsChange}
        fixedHeaderScrollHeight={"59vh"}
      />
      {/* <div className="flex justify-center md:justify-end mt-5 ">
        <button
          type="button"
          className={`bg-primary text-white px-4 py-1 rounded-lg md:w-auto`}
        >
          Generate Report
        </button>
      </div> */}
    </div>
  );
};

export default Hoc(Projects);
